import React from "react";
import { Tag } from "antd";
import { ISSUE_STATUSES } from "../../constants/issue";

const IssueStatusTag = ({ statusKey }) => {
  const status = ISSUE_STATUSES.find((status) => status.key === statusKey);

  return <Tag color={status?.color || "gray"}>{status?.name || statusKey}</Tag>;
};

export default IssueStatusTag;
